import { render, staticRenderFns } from "./wxwl-waixiao.vue?vue&type=template&id=0dd1381a"
import script from "./wxwl-waixiao.vue?vue&type=script&lang=js"
export * from "./wxwl-waixiao.vue?vue&type=script&lang=js"
import style0 from "./wxwl-waixiao.vue?vue&type=style&index=0&id=0dd1381a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports